<ng-container *ngFor="let row of filteredData |paginate: config; let i = index ;">
  <tr lib-row [datarow]="row" (onRowClick)="click($event)" (onOptionClick)="handleOptionClick($event)"
    (onWatchlistClick)="handleWatchlistClick($event)" [index]="i + offset + 1" [indexCons]="indexCons"
    [customTemplates]="customTemplates" [clickableDataTypes]="clickableDataTypes" [headers]="headers">
  </tr>
</ng-container>
<ng-container>
  <tr *ngIf="totalRowStatus" lib-total-row [totalrow]="totalData" [noData]="noData" [indexCons]="indexCons"
    [customTemplates]="customTemplates">
  </tr>
</ng-container>
<ng-container *ngIf="noData">
  <tr>
    <td [attr.colspan]="totalCols" class="text-center text-danger">No Data to Display</td>
  </tr>
</ng-container>
